<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding">
          <span class="arch">
            <p>I studied a sign just now, and I do not recognise its meaning. </p>

            <p>I don’t even know how long I have stood here.</p>

            <p>My eyes do not blink. There is something missing from them. </p>

            <p>I look at my reflection in the window of the building in front of me.</p>

            <p>I see myself, a man I recognise as myself, but I cannot find a name.</p>

            <p>I wore glasses once, but not now. </p>

            <p>I close my eyes in the hope that things will change in the darkness.</p>

            <p>I opened my eyes again and I was still standing here. </p>

            <p>Somehow I know that I wasn’t here yesterday, and yet I am here today, and I remember yesterday as if it was only a few hours ago. </p>

            <p>Somehow I know I walked another set of streets under a different sky, I walked in the rain, and it was so much more familiar. </p>

            <p>I don’t think these streets are mine, and I don’t know what to do with that feeling.</p>

            <p>I hold my breath for a moment</p>

            <p>.</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'The Architect'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
